import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import Seo from "@/components/Seo";

const PaymentResult = ({ mode }) => {
  const [params] = useSearchParams();
  const directPaid = params.get("paid") === "1";
  const state = mode === "cancel" ? "cancelled" : directPaid ? "paid" : "pending";

  return (
    <div className="min-h-screen bg-forest text-cream flex items-center justify-center px-5 grain relative" data-testid="payment-result-page">
      <Seo
        title="Payment Status | Chai Times"
        description="Chai Times payment status page."
        path={mode === "cancel" ? "/payment/cancel" : "/payment/success"}
        noindex
      />
      <div className="w-full max-w-md text-center">
        <img src="/logo.png" alt="Chai Times" className="w-24 h-24 mx-auto mb-8 rounded-full" />
        {state === "paid" && (
          <div data-testid="payment-success">
            <CheckCircle2 size={48} className="mx-auto text-gold mb-6" />
            <h1 className="font-serif font-black text-4xl md:text-5xl">Payment received.</h1>
            <p className="text-cream/70 mt-5 leading-relaxed">
              Your order is confirmed. We'll call you shortly to arrange delivery of your chai.
            </p>
            <Link to="/shop" data-testid="payment-success-shop-link" className="mt-9 inline-block rounded-full px-8 py-4 font-mono text-xs uppercase tracking-[0.2em] bg-terracotta text-cream hover:bg-gold hover:text-charcoal transition-colors">
              Continue Shopping
            </Link>
          </div>
        )}
        {state === "pending" && (
          <div data-testid="payment-pending">
            <Loader2 size={40} className="mx-auto text-gold mb-6" />
            <h1 className="font-serif font-black text-4xl">Payment status unknown</h1>
            <p className="text-cream/70 mt-5 leading-relaxed">
              If money was deducted, contact us and we'll confirm your order right away.
            </p>
            <Link to="/shop" data-testid="payment-pending-shop-link" className="mt-9 inline-block rounded-full px-8 py-4 font-mono text-xs uppercase tracking-[0.2em] bg-terracotta text-cream hover:bg-gold hover:text-charcoal transition-colors">
              Back to Shop
            </Link>
          </div>
        )}
        {state === "cancelled" && (
          <div data-testid="payment-cancelled">
            <XCircle size={48} className="mx-auto text-terracotta mb-6" />
            <h1 className="font-serif font-black text-4xl md:text-5xl">Payment cancelled.</h1>
            <p className="text-cream/70 mt-5 leading-relaxed">
              No charge was made. Your kulhads are waiting whenever you're ready.
            </p>
            <Link to="/shop" data-testid="payment-cancel-shop-link" className="mt-9 inline-block rounded-full px-8 py-4 font-mono text-xs uppercase tracking-[0.2em] bg-terracotta text-cream hover:bg-gold hover:text-charcoal transition-colors">
              Back to Shop
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentResult;
